import { useEffect, useState } from "react";
import { Eye, Users, BookOpen, Download, MessageSquare, HelpCircle, ClipboardList, TrendingUp } from "lucide-react";
import {
  AreaChart, Area, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from "recharts";
import api from "@/lib/api";
import { AdminHeader, StatCard } from "@/components/admin/AdminShared";

const PIE = ["#0F294A", "#DC2626", "#2563EB", "#D97706", "#16A34A", "#7C3AED", "#0891B2", "#DB2777"];

export default function AnalyticsAdmin() {
  const [a, setA] = useState(null);
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/analytics").then((r) => setA(r.data));
    api.get("/dashboard/stats").then((r) => setD(r.data));
  }, []);
  if (!a || !d) return <div className="text-slate-400">Memuat analytics…</div>;
  const m = a.metrics;

  return (
    <div>
      <AdminHeader title="Analytics & Monitoring" description="Statistik trafik, konten, dan partisipasi publik." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <StatCard icon={Eye} label="Page Views" value={m.page_views.toLocaleString("id-ID")} />
        <StatCard icon={Users} label="Unique Visitors" value={m.unique_visitors.toLocaleString("id-ID")} color="text-brandred bg-red-50" />
        <StatCard icon={BookOpen} label="Berita Dibaca" value={m.berita_dibaca.toLocaleString("id-ID")} color="text-blue-600 bg-blue-50" />
        <StatCard icon={Download} label="Media Downloads" value={m.media_downloads} color="text-purple-600 bg-purple-50" />
        <StatCard icon={MessageSquare} label="Aspirasi" value={m.aspirasi} color="text-amber-600 bg-amber-50" />
        <StatCard icon={HelpCircle} label="Pertanyaan" value={m.pertanyaan} color="text-emerald-600 bg-emerald-50" />
        <StatCard icon={ClipboardList} label="Kuis Diikuti" value={m.kuis.toLocaleString("id-ID")} color="text-indigo-600 bg-indigo-50" />
        <StatCard icon={TrendingUp} label="Total Konten" value={m.top_content_count} color="text-navy bg-navy/5" />
      </div>

      <div className="grid lg:grid-cols-3 gap-6 mb-6">
        <div className="lg:col-span-2 bg-white border border-slate-200 rounded-xl p-5">
          <h3 className="font-bold text-navy mb-4">Traffic per Bulan</h3>
          <ResponsiveContainer width="100%" height={260}>
            <AreaChart data={d.pengunjung_per_bulan}>
              <defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor="#DC2626" stopOpacity={0.3} /><stop offset="95%" stopColor="#DC2626" stopOpacity={0} /></linearGradient></defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
              <XAxis dataKey="month" tick={{ fontSize: 12 }} /><YAxis tick={{ fontSize: 12 }} /><Tooltip />
              <Area type="monotone" dataKey="visitors" stroke="#DC2626" strokeWidth={2} fill="url(#g)" name="Pengunjung" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <h3 className="font-bold text-navy mb-4">Aspirasi per Kabupaten/Kota</h3>
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie data={d.aspirasi_by_regency} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={85}>
                {d.aspirasi_by_regency.map((e, i) => <Cell key={i} fill={PIE[i % PIE.length]} />)}
              </Pie>
              <Tooltip /><Legend wrapperStyle={{ fontSize: 10 }} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <h3 className="font-bold text-navy mb-4">Top Berita (Dilihat)</h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={d.top_content} layout="vertical" margin={{ left: 10 }}>
              <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E2E8F0" />
              <XAxis type="number" tick={{ fontSize: 12 }} /><YAxis type="category" dataKey="name" width={140} tick={{ fontSize: 10 }} /><Tooltip />
              <Bar dataKey="views" fill="#0F294A" radius={[0, 6, 6, 0]} name="Dilihat" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <h3 className="font-bold text-navy mb-4">Pertanyaan FAQ Terbanyak</h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={d.top_faq} layout="vertical" margin={{ left: 10 }}>
              <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E2E8F0" />
              <XAxis type="number" tick={{ fontSize: 12 }} /><YAxis type="category" dataKey="name" width={140} tick={{ fontSize: 10 }} /><Tooltip />
              <Bar dataKey="count" fill="#DC2626" radius={[0, 6, 6, 0]} name="Ditanyakan" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
